<template>
	<div class="container">
		<div class="content pa_1">
			<div class="card mb_0">
				<h3 class="title mb_15">{{ $t('rtr_mypage-data.title1') }}</h3>
				<div class="item_list_area">
					<div class="item_list">
						<p>
							{{ $t('rtr_mypage-data.text1') }}<br />
							{{ $t('rtr_mypage-data.text2') }}
							{{ $t('rtr_mypage-data.text3') }}
						</p>
					</div>
					<div class="arrow">
						<img src="@/assets/images/icon/arrow_red.png" alt="" />
					</div>
					<div class="item_list">
						<p>
							{{ $t('rtr_mypage-data.text4') }}<br />
							JM3E642DGFZHIL2IGVJWES3RJVDWSM3S<br />
							{{ $t('rtr_mypage-data.text5') }}
						</p>
					</div>
					<div class="arrow">
						<img src="@/assets/images/icon/arrow_red.png" alt="" />
					</div>
					<div class="item_list">
						<p>
							{{ $t('rtr_mypage-data.text6') }}
						</p>
					</div>
					<div class="arrow">
						<img src="@/assets/images/icon/arrow_red.png" alt="" />
					</div>
					<div class="item_list">
						<p>
							{{ $t('rtr_mypage-data.text7') }}
						</p>
					</div>
				</div>
				<div class="rectangle">
					<img src="@/assets/images/qr_sample.jpg" alt="" />
				</div>
				<div class="item_list2_area">
					<div class="item_list2 mb_10">
						<h2 class="item_list2_title">
							{{ $t('rtr_mypage-data.text8') }}
						</h2>
						<!--						<p class="item_list2_text fs_14 bg_gray1">-->
						<!--							&lt;!&ndash;							{{ $t('rtr_mypage-data.text9') }}&ndash;&gt;-->
						<!--							{{ secret }}-->
						<!--						</p>-->
						<div class="otp_key_area" @click="copyOtp">
							<p class="item_list2_text fs_14 bg_gray1">
								{{ secret }}
							</p>
						</div>
					</div>
					<div class="item_list2">
						<h2 class="item_list2_title">
							{{ $t('rtr_mypage-data.text8') }}<br />
							{{ $t('rtr_mypage-data.text11') }}
						</h2>
					</div>
				</div>
				<div class="button_area">
					<input
						type="text"
						:placeholder="$t('rtr_mypage-data.text12')"
						class="w202"
					/>
					<button class="button_bg_red pa_0">{{ $t('button.otp') }}</button>
				</div>
			</div>
		</div>
	</div>
	<ModalMessageM v-if="messageModal" @closeModal="messageModal = false">
		<div :class="'status_icon ' + modalIcon"></div>
		<p class="status_text">{{ modalStatusMessage }}</p>
		<div class="button_area">
			<button class="fc_red oneBtn" @click="messageModal = false">
				{{ $t('rtr_auth-register.confirm') }}
			</button>
		</div>
	</ModalMessageM>
</template>

<script>
import { commonError } from '@/common/dialog';
import { fetchOtpConfig } from '@/api/config';
import { authenticator } from 'otplib';
import { mapState } from 'vuex';
import { createOtp, deleteOtp } from '@/api/otp';
import ModalMessageM from '@/components/Layout/ModalMessage.m';
import useClipboard from 'vue-clipboard3';

export default {
	name: 'Data.m',
	components: { ModalMessageM },
	data() {
		return {
			otpConfig: [],
			secret: '',
			token: '',
			messageModal: false,
			modalIcon: '',
			modalStatusMessage: '',
		};
	},
	computed: {
		...mapState('auth', ['member_info']),
		...mapState('auth', ['otps']),
		qrUri() {
			if (this.otps.length) {
				return `otpauth://totp/${this.member_info.email_address}${this.otps.length}?secret=${this.secret}&issuer=${window.document.domain}`;
			} else {
				return `otpauth://totp/${this.member_info.email_address}?secret=${this.secret}&issuer=${window.document.domain}`;
			}
		},
	},
	created() {
		this.init();
	},
	methods: {
		init() {
			this.secret = authenticator.generateSecret();
			this.fetchOtpConfig();
		},
		async fetchOtpConfig() {
			const { config } = await fetchOtpConfig().catch(commonError);
			this.otpConfig = config;
		},
		activeOtpHandler() {
			this.activeOtp();
		},
		async activeOtp() {
			const token = this.token.replace(/\D/g, '');
			if (!this.validation()) return;
			await createOtp(token, this.secret)
				.then(() => {
					this.$store.dispatch('auth/getOtps');
				})
				.then(() => {
					window.scrollTo(0, 0);
					this.init();
					this.token = '';
					this.modalIcon = 'success';
					this.modalStatusMessage = 'OTP 활성화가 완료되었습니다.';
					this.messageModal = true;
				})
				.catch(commonError);
		},
		async inactiveOtp() {
			const token = this.token.replace(/\D/g, '');
			if (!this.validation()) return;
			await deleteOtp(this.otps[0].seq, token)
				.then(() => {
					this.$store.dispatch('auth/getOtps');
				})
				.then(() => {
					window.scrollTo(0, 0);
					this.init();
					this.token = '';
					this.modalIcon = 'success';
					this.modalStatusMessage = 'OTP 비활성화가 완료되었습니다.';
					this.messageModal = true;
				})
				.catch(commonError);
		},
		validation() {
			if (!this.token) {
				this.modalIcon = 'error';
				this.modalStatusMessage = '인증번호를 입력해 주세요.';
				this.messageModal = true;
				return false;
			}
			return true;
		},
		copyOtp() {
			try {
				useClipboard().toClipboard(this.secret);
				alert(this.$t('alert.copy_s'));
			} catch (e) {
				alert(this.$t('alert.copy_f'));
			}
		},
	},
};
</script>

<style scoped>
.m_mypage-data .arrow {
	width: 20px;
	height: 20px;
	margin: 15px auto;
}
.m_mypage-data .item_list {
	padding: 15px;
	border-radius: 20px;
	background: #f0f0f0;
}
.m_mypage-data .item_list p {
	font-size: 14px;
	line-height: 1.43;
}
.m_mypage-data .rectangle {
	width: 190px;
	height: 190px;
	padding: 17px;
	margin: 20px auto 30px;
	border-radius: 10px;
	border: solid 5px #ddd;
}
.m_mypage-data .item_list2_title {
	font-size: 14px;
	font-weight: normal;
	line-height: 1.7;
	letter-spacing: -0.4px;
}
.m_mypage-data .item_list2_text {
	padding: 14px;
	border-radius: 10px;
	border: 1px solid #ddd;
}
.m_mypage-data .w202 {
	width: 202px;
	margin-right: 7px;
	border-radius: 10px;
}
.w202::placeholder {
	font-size: 14px;
	color: #ccc;
}
.m_mypage-data .button_area {
	display: flex;
	justify-content: space-between;
	margin-top: 5px;
	margin-bottom: 10px;
}
.m_mypage-data .button_bg_red {
	width: 102px;
}
.otp_key_area {
	position: relative;
	cursor: pointer;
}
.otp_key_area:after {
	position: absolute;
	content: '';
	top: 50%;
	right: 12px;
	transform: translateY(-50%);
	width: 16px;
	height: 16px;
	background-image: url('~@/assets/images/icon/copy.png');
	background-size: cover;
}
</style>
